import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=01831f60&scoped=true&"
import script from "./Sandbox.vue?vue&type=script&lang=js&"
export * from "./Sandbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01831f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01831f60')) {
      api.createRecord('01831f60', component.options)
    } else {
      api.reload('01831f60', component.options)
    }
    module.hot.accept("./Sandbox.vue?vue&type=template&id=01831f60&scoped=true&", function () {
      api.rerender('01831f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Sandbox.vue"
export default component.exports